import React from "react";
import { Drawer } from "antd";
import ExportCSVReport from "../../../../components/ExportCSVReport";
import moment from "moment";

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  let viewData = openUpdateData?.response
    ? JSON.parse(openUpdateData?.response)
    : null;

  viewData = viewData.map((ele) => {
    return {
      ...ele,
      updated: moment(ele.updated).format("YYYY-MM-DD hh:mm:ss a"),
    };
  });
  const tableArray = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>Phone Number</th>
            <th>To Number</th>
            <th>Phone Type</th>
            <th>Ported From</th>
            <th>Ported To</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.phone_number}</td>
                <td>{item.to_number}</td>
                <td>{item.phone_type}</td>
                <td>{item.ported_from}</td>
                <td>{item.ported_to}</td>
                <td>{item.updated}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      footer={
        viewData ? (
          <div className="text-right">
            <ExportCSVReport
              elements={viewData}
              reportName={`ported-out-from-us-report-${Date.now()}`}
              label={true}
            />
          </div>
        ) : (
          false
        )
      }
      className="addModal"
      title={`View Report`}
    >
      <table className="reportTable" width={"100%"}>
        {tableArray(viewData)}
      </table>
      {/* {viewData?.length > 0 ? viewData.map((item: any) => monthlyData(item)) : null} */}
    </Drawer>
  );
};

export default ViewReport;
